import React, { useEffect, useState } from "react";
import { ClipLoader } from "react-spinners";
import { Modal, Box } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import toast, { Toaster } from "react-hot-toast";
import axios from "axios";
import ShowPDF from "./common/showPdf";
import EditPlatformChartByOrderId from "./EditPlatformChartByOrderId";
import EditIcon from "@mui/icons-material/Edit";

const PendingForCollectionByOrder = () => {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [singleBatch, setSingleBatch] = useState();
  const handleOpen = (item) => {
    setOpen(true);
    setSingleBatch(item);
  };
  const handleClose = () => {
    setOpen(false);
  };
  // -----------------------Pagination-------------------------
  const [totalResults, setTotalResults] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsCount = 5;
  const [itemPerPage, setItemPerPage] = useState(15);
  const [pageNumberLimit, setPageLimit] = useState(5);
  const [maxPageLimit, setMaxLimit] = useState(5);
  const [minPageLimit, setMinLimit] = useState(0);
  const [page, setPage] = useState(1);
  const [platformCharges, setPlatformCharges] = useState([]);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [pdfUrl, setPdfUrl] = useState("");
  const [activeModal, setActiveModal] = useState(false);

  const handleModalOpen = (pdfUrl) => {
    setPdfUrl(pdfUrl);
    setActiveModal(true);
  };

  const handleModalClose = () => {
    setPdfUrl("");
    setActiveModal(false);
  };

  const pages = [];
  const handleClick1 = (event) => {
    setCurrentPage(Number(event.target.id));
    setPage(Number(event.target.id));
  };
  for (let i = 1; i <= Math.ceil(totalResults / itemPerPage); i++) {
    pages.push(i);
  }
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItem = "batchesData"?.rows?.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const handlePrevBtn = (e) => {
    if (currentPage === pages[0]) {
      return;
    }
    setPage(currentPage - 1);
    setCurrentPage(currentPage - 1);
    if ((currentPage - 1) % pageNumberLimit === 0) {
      setMaxLimit(maxPageLimit - pageNumberLimit);
      setMinLimit(minPageLimit - pageNumberLimit);
    }
  };
  const handleNextBtn = (e) => {
    if (currentPage === pages.length) {
      return;
    }
    setPage(currentPage + 1);
    setCurrentPage(currentPage + 1);
    if (currentPage + 1 > maxPageLimit) {
      setMaxLimit(maxPageLimit + pageNumberLimit);
      setMinLimit(minPageLimit + pageNumberLimit);
    }
  };
  const renderPageNumbers = pages
    ? pages.map((number, index) => {
        if (number < maxPageLimit + 1 && number > minPageLimit) {
          return (
            <li
              key={index}
              className={
                currentPage === number ? "page-item active" : "page-item"
              }
              style={{ cursor: "pointer" }}
              onClick={(e) => handleClick1(e)}
            >
              <a
                href="#overview-page"
                className="page-link pb-2 ps-3 pt-2 pe-3"
                id={number}
              >
                {number}
              </a>
            </li>
          );
        } else return null;
      })
    : "";

  // -----------------Pagination Ends here---------------------

  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  };

  const getBatches = async (searchQuery) => {
    try {
      setLoading(true);
      let url = `/api/platform/charges?collection_status=Pending&page=${currentPage}&limit=${itemPerPage}`;

      if (searchQuery !== "" && searchQuery !== undefined) {
        const parsedQuery = parseInt(searchQuery);
        if (!isNaN(parsedQuery)) {
          url += `&order_id=${parseInt(searchQuery)}`;
        } else {
          url += `&party_name=${encodeURIComponent(searchQuery)}`;
        }
      }
      const response = await axios.get(url);

      if (response.data.status === false) {
        setError(response.data.message);
        setLoading(false);
        setPlatformCharges([]);
        setTotalResults(0);
        return;
      } else {
        setError(null);
      }

      setPlatformCharges(response.data.platform_charges.rows);
      setTotalResults(response.data.platform_charges.count);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      getBatches(searchQuery);
    }, 800);
    return () => clearTimeout(timeout);
  }, [searchQuery, page, currentPage]);

  const updateChargeStatus = async (chargeId, totalPlatformCharges) => {
    if (window.confirm("Do you want to mark it as collected?"))
      try {
        const actioner = JSON.parse(
          localStorage.getItem("user_detail")
        ).user_name;
        const response = await axios.patch(
          `/api/platform/charges/${parseInt(chargeId)}`,
          {
            collection_status: "COLLECTED",
            collection_amount: totalPlatformCharges,
            collection_date: getTodayDate(),
            actioner: actioner,
            action_stamp: getTodayDate(),
          }
        );

        if (response.status === 200) {
          toast.success("Successfully updated the status.");
          getBatches(searchQuery);
        }
      } catch (error) {
        console.error("Error updating charge status", error);
        toast.error("Error updating the status.");
      }
  };

  return (
    <>
      <div className="row mx-0 mt-2">
        <div className="col-12 col-sm-12 col-md-6 col-lg d-flex gap-3">
          <input
            type="text"
            className="form-control shadow-sm border border-dark"
            placeholder="Search by Order ID or Party Name"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          {/*<select
                    className="form-select shadow-sm border border-dark"
                    aria-label="Default select example"
                >
                    <option selected>--Apply filter--</option>
                    <option value="1">One</option>
                    <option value="2">Two</option>
                    <option value="3">Three</option>
                </select>*/}{" "}
        </div>
        {/*<div className="col-12 col-sm-12 col-md-6 col-lg-6 d-flex justify-content-end">
                    <select
                        className="form-select w-50 shadow-sm border border-dark"
                        aria-label="Default select example"
                    >
                        <option selected>--Select Lending Partner--</option>
                        <option value="1">One</option>
                        <option value="2">Two</option>
                        <option value="3">Three</option>
                    </select>{" "}
              </div>*/}
      </div>
      <div className="row mx-0 mt-3 border border-secondary shadow"></div>
      {loading ? (
        <div className="fixed top-0 left-0 right-0 bottom-0 bg-gray-900 bg-opacity-50 flex items-center justify-center">
          <ClipLoader color="#4A1AC7" size={50} />
        </div>
      ) : null}
      <div
        className="row mx-0 rounded-3 mt-3 overflow-auto pb-2 shadow-sm m-1"
        style={{ border: "2px solid grey" }}
      >
        <div
          className="col-12 px-0"
          style={{ height: "430px", overflowY: "auto" }}
        >
          <table class="table table-hover">
            <thead class="thead-dark">
              <tr>
                <th scope="col">Order ID</th>
                <th scope="col">Party Name</th>
                <th scope="col">Lending Partner</th>
                <th scope="col">RM</th>
                <th scope="col">Total Disbursed Amount</th>
                <th scope="col">Platform Charges</th>
                <th scope="col">GST</th>
                <th scope="col">Total Platform Charge</th>
                <th scope="col">Invoice</th>
                <th scope="col">Update Platform Charge</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody className="text-center">
              {loading ? (
                <div className="fixed top-0 left-0 right-0 bottom-0 bg-gray-900 bg-opacity-50 flex items-center justify-center">
                  <ClipLoader color="#4A1AC7" size={50} />
                </div>
              ) : null}
              {platformCharges.map((charge) => (
                <tr key={charge.id}>
                  <td className="text-center">{charge.order_id}</td>
                  <td className="text-center">{charge.party_name}</td>
                  <td className="text-center">{charge.lending_partner}</td>
                  <td className="text-center">{charge.relationship_manager}</td>
                  <td className="text-center">
                    {charge.total_disbursed_amount}
                  </td>
                  <td className="text-center">{charge.platform_charges}</td>
                  <td className="text-center">{charge.gst}</td>
                  <td className="text-center">
                    {charge.total_platform_charges}
                  </td>
                  <td className="text-center">
                    <td className="text-center">
                      <div className="flex">
                        <button
                          className="btn btn-sm btn-outline-dark px-2 text-light mr-3"
                          style={{ backgroundColor: "#00213D" }}
                          onClick={() => handleModalOpen(charge.invoice)}
                        >
                          View Invoice
                        </button>
                        <button
                          className="btn btn-sm btn-outline-dark px-2 text-light"
                          style={{ backgroundColor: "#00213D" }}
                        >
                          <a
                            href={charge.invoice}
                            style={{
                              textDecoration: "none",
                              color: "inherit",
                            }}
                          >
                            Download Invoice
                          </a>
                        </button>
                      </div>
                    </td>
                  </td>
                  <td className="text-center">
                    <td className="text-center">
                      <button
                        className="btn btn-sm btn-outline-dark px-2 text-light"
                        style={{ backgroundColor: "#00213D" }}
                        onClick={() => handleOpen(charge)}
                      >
                        <EditIcon />
                      </button>
                    </td>
                  </td>
                  <td className="text-center">
                    <td className="text-center">
                      <button
                        className="btn btn-sm btn-outline-dark px-2 text-light"
                        style={{ backgroundColor: "#00213D" }}
                        onClick={() =>
                          updateChargeStatus(
                            charge.id,
                            charge.total_platform_charges
                          )
                        }
                      >
                        Mark as collected
                      </button>
                    </td>
                  </td>
                </tr>
              ))}
            </tbody>
            {error && (
              <tfoot>
                <tr>
                  <td colSpan={10} className="text-center py-4">
                    <span className="text-lg font-semibold text-gray-500">
                      No orders found
                    </span>
                  </td>
                </tr>
              </tfoot>
            )}
          </table>
        </div>
      </div>
      <div className="row mx-auto mt-3">
        <div className="col-sm-6 pt-2 d-flex justify-content-start">
          Showing {15 * currentPage - (15 - 1)} to{" "}
          {15 * currentPage > totalResults ? totalResults : 15 * currentPage}{" "}
          entries of {totalResults ? totalResults : ""}
          {console.log(totalResults)}
        </div>
        <div className="col-sm-6 d-flex justify-content-end">
          <ul className="pagination">
            <li className="page-item pt-1 pl-2 pr-2 border">
              <a
                href="#overview-page"
                className={currentPage !== pages[0] ? "show" : "hideBtn"}
                onClick={(e) => handlePrevBtn(e)}
              >
                Prev
              </a>
            </li>
            {renderPageNumbers}
            <li className="page-item pt-1 pl-2 pr-2 border border-left-0">
              <a
                href="#overview-page"
                className={currentPage !== pages.length ? "show" : "hideBtn"}
                onClick={(e) => handleNextBtn(e)}
              >
                Next
              </a>
            </li>
          </ul>
        </div>
      </div>
      <Modal
        open={activeModal}
        onClose={handleModalClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            width: 1000,
            height: 720,
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            borderRadius: 24,
            p: 4,
            overflowY: "auto",
          }}
        >
          <div>
            <IconButton
              aria-label="close"
              style={{ position: "absolute", right: "8px", top: "8px" }}
              onClick={handleModalClose}
            >
              <CloseIcon />
            </IconButton>
          </div>
          <div className="flex flex-col items-center justify-center space-y-5 h-full">
            <ShowPDF pdfUrl={pdfUrl} />
          </div>
        </Box>
      </Modal>
      <Toaster />
      <EditPlatformChartByOrderId
        open={open}
        handleClose={handleClose}
        singleBatch={singleBatch}
        getBatches={getBatches}
      />
    </>
  );
};

export default PendingForCollectionByOrder;
